/**
 * `tna.*` wire contract (garment Increment 4, `garment.tna`).
 *
 * The Time & Action milestone calendar. Behind
 * `entitledProcedureFor("garment.tna")`.
 */
import { z } from "zod";
import { uuid, isoDate } from "../_common.js";

export const milestoneStatus = z.enum(["done", "current", "overdue", "future"]);

export const getForStyleInput = z.object({ styleId: uuid });

export const generateInput = z.object({ styleId: uuid });
export const generateOutput = z.object({ count: z.number().int().nonnegative() });

export const updateMilestoneInput = z.object({
  milestoneId: uuid,
  plannedDate: isoDate.optional(),
  /** Set to a date to mark done, or null to clear. */
  actualDate: isoDate.nullable().optional(),
});
export const updateMilestoneOutput = z.object({ id: uuid });

export const tnaView = z.object({
  styleId: uuid,
  hasTna: z.boolean(),
  exFactoryDate: isoDate.nullable(),
  pcdDate: isoDate.nullable(),
  milestones: z.array(
    z.object({
      id: uuid,
      position: z.number().int().positive(),
      code: z.string(),
      label: z.string(),
      ownerRole: z.string().nullable(),
      plannedDate: isoDate,
      actualDate: isoDate.nullable(),
      status: milestoneStatus,
      daysOverdue: z.number().int().nonnegative(),
    }),
  ),
  totalMilestones: z.number().int().nonnegative(),
  doneCount: z.number().int().nonnegative(),
  overdueCount: z.number().int().nonnegative(),
  slippageDays: z.number().int().nonnegative(),
});
export const getForStyleOutput = tnaView;

export type MilestoneStatus = z.infer<typeof milestoneStatus>;
export type TnaViewWire = z.infer<typeof tnaView>;
